import { FeatureNameEnum } from 'constants-content';
import { MergeMethodEnum } from './MergeMethodEnum';

/**
 * Options for copying a template over.
 *
 * Uses a trinary for values.
 *  - undefined  not available.
 *  - false available but do not copy.
 *  - true  available and copy.
 */
export type TemplateImportOptionsType = {
  name: boolean | undefined;
  description: boolean | undefined;
  subtitle: boolean | undefined;
  tags: boolean | undefined;
  category: boolean | undefined;
  logo: boolean | undefined;
  color: boolean | undefined;
  backgroundColor: boolean | undefined;
  backgroundImage: boolean | undefined;
  icon: boolean | undefined;
  resetPeriod: boolean | undefined;
  appearance: boolean | undefined;
  translations: boolean | undefined;
  placements: MergeMethodEnum | undefined;
  data: MergeMethodEnum | undefined;
  workflows: MergeMethodEnum | undefined;
  notifications: MergeMethodEnum | undefined;
  metatags: MergeMethodEnum | undefined;
  features: {
    [key in keyof typeof FeatureNameEnum]: boolean | undefined;
  };
  isInteractive: boolean | undefined;
};

export const defaultImportOptions: TemplateImportOptionsType = {
  name: true,
  description: true,
  subtitle: true,
  tags: true,
  category: true,
  logo: true,
  color: true,
  backgroundColor: true,
  backgroundImage: true,
  icon: true,
  resetPeriod: true,
  appearance: true,
  translations: true,
  placements: MergeMethodEnum.Copy,
  data: MergeMethodEnum.Copy,
  workflows: MergeMethodEnum.Copy,
  notifications: MergeMethodEnum.Copy,
  metatags: MergeMethodEnum.Copy,
  // @ts-expect-error ts-migrate(2739) FIXME: Type '{ Cancelable: false; Deliverable: false; Ent... Remove this comment to see the full error message
  features: {
    Cancelable: false,
    Deliverable: false,
    Entries: false,
    EssensysProduct: false,
    Inventory: false,
    GuestInvite: false,
    Menu: false,
    Payment: false,
    QRCodeCheckin: false,
    Quantity: false,
    RemoteFetch: false,
    Reservable: false,
    Reset: false,
    Scheduled: false,
    Shipping: false,
    SocialOptions: false,
    Statuses: false,
    SubmitOnBehalfOf: false,
    TimeAvailability: false,
    UseCompanyPermissions: false,
  },
  isInteractive: true,
};
